<script setup lang="ts">
import { NxtInput, NxtPhoneNumberInput, NxtTextarea, NxtFilepicker, NxtDatepicker } from '@future-harry/nxt-styles';
import NxtAddressField from '@/core/components/form-elements/NxtAddressField.vue';

const model = defineModel<any>();
const props = defineProps<{ applicationFields: Record<string, any>; errors?: Record<string, string> }>();
const acceptedFiles = '.pdf,.doc,.docx';
const acceptedPhotoFiles = '.jpg,.jpeg,.png';
</script>

<template>
   <div class="form">
      <!-- always required -->
      <div class="form-row">
         <NxtInput name="first_name" :label="$tb('public.form.first_name')" v-model="model.first_name" :errors="errors" />
      </div>
      <div class="form-row">
         <NxtInput name="last_name" :label="$tb('public.form.last_name')" v-model="model.last_name" :errors="errors" />
      </div>
      <div class="form-row">
         <NxtPhoneNumberInput v-model="model.phone_number" :label="$tb('public.form.phone')" name="phone_number" :errors="errors" />
      </div>
      <!-- visibility defined in settings -->
      <div v-if="applicationFields.email !== null" class="form-row">
         <NxtInput name="email" :label="$tb('public.form.email')" type="email" v-model="model.email" :errors="errors" />
      </div>
      <div v-if="applicationFields.address !== null" class="form-row">
         <div class="nxt-form-group">
            <label class="nxt-form-group__label">{{ $tb('public.form.address') }}</label>
            <NxtAddressField v-model="model.address" name="address" :errors="errors" />
         </div>
      </div>
      <div v-if="applicationFields.motivation !== null" class="form-row">
         <NxtTextarea name="motivation" :label="$tb('public.form.motivation')" v-model="model.motivation" :errors="errors" />
      </div>
      <div v-if="applicationFields.cv !== null" class="form-row">
         <div class="nxt-form-group">
            <label class="nxt-form-group__label">{{ $tb('public.form.cv') }}</label>
            <NxtFilepicker v-model="model.cv" :accept="acceptedFiles" :name="'cv'" :placeholder="$tb('public.form.cv')" :errors="errors" />
         </div>
      </div>
      <div v-if="applicationFields.photo !== null" class="form-row">
         <div class="nxt-form-group">
            <label class="nxt-form-group__label">{{ $tb('public.form.photo') }}</label>
            <NxtFilepicker
               v-model="model.photo"
               :accept="acceptedPhotoFiles"
               :name="'photo'"
               :placeholder="$tb('public.form.photo')"
               :errors="errors"
            />
         </div>
      </div>
      <div v-if="applicationFields.date_of_birth !== null" class="form-row">
         <NxtDatepicker v-model="model.date_of_birth" name="date_of_birth" :label="$tb('public.form.date_of_birth')" :errors="errors" />
      </div>
   </div>
</template>

<style scoped lang="scss">
.form {
   display: flex;
   flex-direction: column;
   gap: var(--nxt-gutter);

   :deep(.nxt-address) {
      padding: 0;
      background-color: transparent;

      .nxt-form-group__label,
      .nxt-address__heading {
         display: none;
      }

      input {
         background-color: var(--nxt-extralight-grey);
      }
   }
}
</style>
